import {UserRole} from 'enums';

// Singleton for interacting with users
class _UserService {

    // This gets set by App.tsx when okta reads the stored token
    public oktaUserInfo: {
        token?: string,
        role?: UserRole,
        id?: string,
        sub?: string,
    } = {};

    public parseOktaUserInfo(authState) {
        let role = UserRole.ViewOnly;
        let id = undefined;
        let token = authState?.accessToken?.value;
        let sub = "";

        // We'll read the user info from the claims in the access token
        const claims = authState?.accessToken?.claims
        if (claims) {
            id = claims.cfa_guid;
            sub = claims.sub;
            const cfaPerms = claims.cfa_perms?.SMARTEQUIP_PINGER;
            
            if (cfaPerms) {
                if (cfaPerms['ADMIN']) {
                    role = UserRole.Admin;
                } else if (cfaPerms['FULL-USER']) {
                    role = UserRole.FullUser;
                } else if (cfaPerms['LIMITED-USER']) {
                    role = UserRole.LimitedUser;
                } else if (cfaPerms['LOGIN']) {
                    role = UserRole.ViewOnly;
                } else {
                    console.error(`Didn't find a valid role in cfa_perms. authState: `, authState);
                }
            } else {
                console.error(`No cfa_perms map in token. authState: `, authState);
            }
        } else {
            console.error('No claims found in token. authState: ', authState);
        }

        this.oktaUserInfo = {
            token: token,
            role: role,
            id: id,
            sub: sub,
        };
    }

    public reset() {
        this.oktaUserInfo = {};
    }
}

export const UserService = new _UserService();